import {
  EBetSlipBetSubmissionType,
  EBetSubmissionRejectionReason,
  TBetSlipBetSubmissionExoticsType,
} from '@/components/Betslip/Services/Betslip.types';
import { getThemeName } from '@/helpers/getThemeName';

const STRINGS = {
  Generic: {
    Home: '首页',
    WinPlace: '取胜/名次',
    FixedWin: '固定赢',
    FixedPlace: '固定地点',
    FixedEachWay: 'Fixed Each Way',
    PickDate: 'Pick a Date',
    Close: '关闭',
    Email: '电子邮件',
    Bet: 'Bet',
    Bets: '投注',
    Password: '密码',
    TermsConditions: '使用条款',
    PrivacyPolicy: '隐私政策',
    ResponsibleGambling: '负责任博彩',
    ResponsibleGamblingTools: '负责任的博彩工具',
    And: '和',
    Policy: '政策',
    RestrictedFuture: 'Date cannot be in the future',
    RestrictedPast: 'Date cannot be in the past',
    Logout: '登出',
    Version: 'Version',
    SaveChanges: '保存更改',
    Verified: 'Verified',
    Unverified: 'Unverified',
    Markets: ' Markets',
    Race: 'Race',
    SeeAll: 'See All',
    Bonus: '礼金投注: ',
    loading: 'Loading...',
    Required: 'Required',
    HelpLine: '1800 858 858',
    GamblersHelp: 'Gambler’s Help',
    GamblingVic: '澳大利亚维多利亚州博彩与赌场管理委员会',
    ErrorOccurred: 'An error occurred. Please try again',
    SelectPlaceholder: 'Please Select',
    Login: '登录',
    Join: '立即加入',
    SignUp: '报名',
    Stake: '注金',
    EmptyStake: '0.00',
    Flexi: 'Flexi',
    Scratched: 'Scratched',
    Runners: '个参赛者',
    Win: '奖金',
    Hello: '您好',
    HideBalance: 'Hide balance',
    Balance: '余额',
    Withdrawable: 'Withdrawable',
    Deposit: '存款',
    RateLimitError: 'Please wait a few moments and try again',
  },
  Onboarding: {
    Step1: {
      PageTitle: '| 报名',
      Header: 'Welcome, Let’s get you set up!',
      Welcome: `Welcome to ${getThemeName()}`,
      Subheader: 'Please enter your details.',
      EmailInputPlaceholder: 'eg. john@email.com',
      EmailInputError: 'Email requirements not met',
      EmailInputEmpty: '请输入有效的邮箱地址',
      PasswordInputLabel: '密码',
      PasswordInputPlaceholder: '••••••••',
      PasswordInputError: 'Password requirements not met',
      PasswordNoSpaces: 'Password cannot contain any spaces',
      PasswordEmpty: 'A password is needed',
      PasswordRule1: '包含小写和大写字母',
      PasswordRule2: '至少包含 1 个数字',
      PasswordRule3: '密码长度超过 8 个字符',
      PasswordRule4: '密码不可包含空格',
      AgeAcknowledgement:
        '点击“立即加入”，即表示我确认我已年满 18 周岁，目前未处于自我禁止状态，已阅读并同意 GoldenBet888 的条款和条件以及隐私政策。',
      AgeAcknowledgementError:
        'Sorry, you need to agree before you can create an account',
      PromotionAcknowledgement: `我同意接收 ${getThemeName()} 的信息和推广材料，并且我了解自己可以随时取消此服务。`,
      Button: '创建账户',
      Login: '已有账户？',
      LoginCTA: '登录',
    },
    Step2: {
      PageTitle: '| Verification',
      Header: "Let's get you verified!",
      Subheader:
        'This info will allow us to make sure you are a real person and lets us check that you are OK to start betting with us.',
      TitleInputLabel: '称谓',
      TitleOptions: ['Mr', 'Miss', 'Ms', 'Dr', 'Other'],
      TitleRequiredError: 'Title is required',
      FieldTooLongErrorText: 'Field is too long',
      FirstNameInputLabel: '名',
      FirstNameErrorText: 'First Name is required',
      LastNameInputLabel: '姓',
      LastNameErrorText: 'Last Name is required',
      ValidNameRequiredErrorText: 'Valid name is required',
      MobileInputLabel: '手机',
      MobilePlaceholder: 'eg. 0412345678',
      MobileRequiredErrorText: 'Mobile is required',
      MobileNumberOnlyError: 'Mobile field can only contain numbers',
      MobileNumberAUOnlyError: 'Must be an Australian mobile number.',
      AddressInputLabel: '居住地址',
      AddressInputPlaceholder: '* Address must match your ID',
      AddressInputManualPlaceholder: 'Manual Entry',
      AddressRequiredErrorText: 'Residential Address is required',
      AddressInputManualEntry: '看不到您的地址？请手动输入',
      StreetNumberInputLabel: '街道号码',
      StreetNumberRequiredError: 'Street number is required',
      StreetNameInputLabel: '街道名称',
      StreetNameRequiredError: 'Street name is required',
      SuburbInputLabel: '区/县',
      SuburbRequiredError: 'Suburb is required',
      StateInputLabel: '州/省',
      StateRequiredError: 'State is required',
      PostcodeInputLabel: '邮政编码',
      PostcodeRequiredError: 'Postcode is required',
      PostcodeLengthError: 'Postcode must be 4 digits',
      DobInputLabel: '出生日期',
      DobInputError:
        'Sorry, you need to be over 18 years of age to use this platform',
      DobRequiredErrorText: 'Date of Birth is required',
      VerificationErrorText:
        "Sorry, we couldn't verify you. Please try again later.",
      SkipVerificationOption: 'Please skip for now and manually verify me',
      VerificationError: 'There was an error verifying you',
      Button: 'Get Verified',
      PromoCodeLabel: 'Code',
    },
    Step3: {
      PageTitle: '| 存款限额',
      Header: 'Congrats! You are ready to go',
      Subheader: 'Would you like to set up a deposit limit?',
      RadioOption1: '我已阅读并理解这些好处，但不想设置存款限额',
      RadioOption2: '我想设置存款限额',
      LimitAmountInputLabel: '限制金额',
      LimitPeriodInputLabel: '限额时长',
      LimitPeriodOptions: ['7 Days', '14 Days', '28 Days'],
      LimitAmountRequiredText:
        'As you have chosen to add a deposit limit, your limit amount is required',
      LimitDurationRequiredText:
        'As you have chosen to add a deposit limit, your limit duration is required',
      LimitNumbersOnlyError: 'Deposit limit can only contain numbers',
      DepositLimitError: 'There was an error creating your deposit limit',
      Button: '继续',
    },
    LocationNotAllowed: {
      PageTitle: '| Location not allowed',
      Header: 'We Apologise',
      Subheader: `You seem to be using ${getThemeName()} from a location we do not currently support.`,
      BodyCopy:
        "If you are in a country that we are licensed to operate in and you think there's an error, please contact us at ",
      OurOffices: 'Our Offices',
      LocationEnquiry: 'Location Enquiry - ',
    },
    FirebaseErrorMessages: {
      ErrorCreatingAccount: 'There was an issue creating your account:',
      WrongCredentials:
        "Your credentials don't seem to be correct. Please try again.",
      EmailInUse: 'This email address is already in use.',
      UserDisabled: 'Your account has been disabled.',
      UnspecifiedError:
        'An unspecified error occurred. Please try again later.',
      UserNotFound: 'Unable to find your account.',
      TooManyRequests:
        'Access to this account has been temporarily disabled due to many failed login attempts.',
    },
    SignUpErrorMessages: {
      ContactCustomerService: 'Error: Contact Customer Service',
      EmailExists: 'This email address is already in use.',
      StreetNumberRequired:
        'Please enter an address that contains a street number.',
      SuspendedOrExcludedOrClosed: `We were unable to complete your ID verification, please login to try again.
      If the issue persists please contact service@${getThemeName().toLowerCase()}.com.au`,
    },
    ForgotPassword: {
      PageTitle: '| 忘记密码',
      Header: '忘记密码',
      BodyText:
        'Please enter your email below and we will send you a link to reset your password.',
      SuccessText: '谢谢',
      LoginLink: 'Click here to login',
      Button: '发送重置链接',
    },
    Login: {
      PageTitle: '| 登录',
      Header: 'Welcome Back',
      ForgotPassword: '忘记密码？',
      Button: '登录',
      NotSignedIn: 'You are not signed in.',
      AutoLogoutMessage:
        'You have been automatically signed out due to inactivity. Please sign in again.',
      Signup: "Don't have an account?",
      SignupCTA: '立即加入',
      Error_Temporary_Exclusion:
        'Sorry... Your account has been locked until DATE',
      Error_Suspended_KYC:
        'We are unable to verify your identity. Please contact customer service to continue',
      Error_Closed_Account:
        'Your account has been closed. Please contact support to reactivate the account',
      Error_Permanent_Exclusion: 'Your account has been permanently excluded',
      Verification_In_Progress:
        'Thank you for your verificaton submission, your verification is currently in progress, please come back later to access your account.',
    },
  },
  BetSlip: {
    betSlipHeading: '投注单',
    betSlipReviewHeading: 'Review & Confirm',
    betSlipReceiptHeading: 'Bet Receipt',
    reuseSelectionsButton: 'Reuse Selections',
    potentialReturns: '预计返还',
    estPayout: '预计返还',
    negativeError: 'Negative stake',
    useBonusBet: '礼金投注',
    eachWay: 'Each Way',
    bonusBetApplied: 'Bonus Applied',
    eventRules: {
      ruleHeading: 'Event Rules: ',
      noPlace: 'No place betting available on this race',
      twoPlaceDividends: 'Only two place dividends paid',
      threePlaceDividends: 'Three place dividends paid',
    },
    emptyBetsModal: {
      warningHeading: 'Warning',
      emptyModalMessage: 'You must enter a stake to place a bet',
      modalButton: '好的',
    },
    modal: {
      stakeAllSingles: 'Stake all singles',
    },
    betSlipBetCard: {
      stake: '注金',
      bal: 'Bal',
      placed: 'Bet ID: ',
      placedDate: 'Bet placed on: ',
      emptyStakeError: 'Stake required',
      negativeValueError: 'Negative value',
      invalidStake: 'Invalid Stake',
      emptyFlexError: 'Flexi required',
      betIDLabel: 'Bet ID:',
      fixedPriceWinLabel: '取胜 (Fixed Price)',
      fixedPricePlaceLabel: '名次 (Fixed Price)',
      winLabel: '取胜',
      combos: '组合',
      reviewStakeMessage: '注金',
      stakePerCombo: 'Stake per combo',
      partialBetApprovalInfo: '% has been ',
      betApprovalInfo: 'Your bet has been ',
      unfortunateReject: 'Unfortunately, your bet has been rejected.',
      approved: 'approved.',
      rejected: 'rejected.',
      pendingApproval: 'Pending approval',
      thisEventIsClosed: 'Betting has closed on your selection.',
      Multis: {
        estReturns: '预计回报',
        estNoReturns: '$0.00',
        legMulti: 'Leg Multi',
        leg: 'Leg',
      },
      errors: {
        // To Do. Confirm these values
        [EBetSubmissionRejectionReason.OddsChange]:
          'Your odds have changed. Please review your selections before confirming.',
        [EBetSubmissionRejectionReason.InsufficentFund]:
          'Your balance is too low. Lower your stake or make a deposit to cover your bets.',
        [EBetSubmissionRejectionReason.PropositionClosed]:
          'Betting has closed on your selection.',
        [EBetSubmissionRejectionReason.HighRisk]:
          'Your bet has not been accepted.',
        [EBetSubmissionRejectionReason.AccountClosed]:
          'We were unable to process your request. Contact support for further assistance.',
        [EBetSubmissionRejectionReason.ManualRejection]:
          'Unfortunately, your bet has been rejected.',
        [EBetSubmissionRejectionReason.UnknownError]:
          'We were unable to process your request. Contact support for further assistance.',
        [EBetSubmissionRejectionReason.UnsupportedBetType]:
          'Unable to place this bet type.',
        [EBetSubmissionRejectionReason.NegativeStake]: 'Invalid Stake.',
        [EBetSubmissionRejectionReason.PlaceBetInvalidFieldSize]:
          'Betting is no longer available on your selection.',
        [EBetSubmissionRejectionReason.DuplicateRequest]:
          'Bet Rejected, duplicate identified.',
        [EBetSubmissionRejectionReason.BetslipRejection]:
          'We were unable to process your request. Contact support for further assistance.',
        [EBetSubmissionRejectionReason.AlreadyProcessedRequest]:
          'We were unable to process your request. Contact support if the issue persists.',
        [EBetSubmissionRejectionReason.SelectionExpansionRejection]:
          'We were unable to process your request. Contact support if the issue persists.',
        [EBetSubmissionRejectionReason.InsufficientLegsForMulti]:
          'Insufficient legs to place a Multi.',
        [EBetSubmissionRejectionReason.ExceededMaximumLegsForMulti]:
          'A Multi Bet must not exceed 20 legs.',
        [EBetSubmissionRejectionReason.MultipleLegsInEventForMulti]:
          'Your selections cannot be combined into a Multi.',
        [EBetSubmissionRejectionReason.InvalidProposition]:
          'Betting is no longer available on your selection.',
        [EBetSubmissionRejectionReason.UnavailableBetType]:
          'Your bet has not been accepted.',
        [EBetSubmissionRejectionReason.MaxStakeExceeded]:
          'Your bet has exceeded the maximum stake limit of {max_stake_limit}',
        [EBetSubmissionRejectionReason.MultiNotAllowed]:
          'One of more of your selections are not allowed in a multi',
        [EBetSubmissionRejectionReason.InvalidPriceType]:
          'Betting is no longer available on your selection.',
        [EBetSubmissionRejectionReason.FailMinimumStake]:
          'Minimum bet size is $1',
        [EBetSubmissionRejectionReason.FailMinimumOdds]:
          'Your bet has been rejected due to minimum odds requirements.',
        [EBetSubmissionRejectionReason.BonusNotAllowed]:
          'Bonus bets not accepted on this market',
        [EBetSubmissionRejectionReason.ExceededMaximumBetsForEvenShot]:
          'Sorry, you have already placed Even Shot bet on this race',
        [EBetSubmissionRejectionReason.EvenShotOddsChange]:
          'Sorry, this Even Shot proposition is no longer available. Please refresh or try a different race',
        [EBetSubmissionRejectionReason.InsufficentBonusFund]:
          'Sorry, your Bonus Balance is too low to place this bet',
        [EBetSubmissionRejectionReason.MysteryBetOddsChange]:
          'Sorry, this Mystery Bet proposition is no longer available. Please refresh or try a different race',
        [EBetSubmissionRejectionReason.MysteryBetRolloverOddsChange]:
          'Sorry, this Mystery Bet proposition is no longer available. Please refresh or try a different race',
        [EBetSubmissionRejectionReason.ToteMultiUnavailable]:
          'Betting is no longer available on your selection.',
      },
    },
    betSlipModal: {
      genericError: 'An unknown error occurred. Please try again',
      boxed: '合票',
      types: {
        [EBetSlipBetSubmissionType.Single]: '单注',
        [EBetSlipBetSubmissionType.Exotics]: 'Exotics',
        [EBetSlipBetSubmissionType.EachWay]: 'Each Way',
        [EBetSlipBetSubmissionType.Multi]: 'Multis',
        [EBetSlipBetSubmissionType.ComboMulti]: 'Combo Multis',
      },
      exoticTypes: {
        [TBetSlipBetSubmissionExoticsType.FirstFour]: 'First 4',
        [TBetSlipBetSubmissionExoticsType.Quinella]: '任意双选',
        [TBetSlipBetSubmissionExoticsType.Exacta]: '精确双选',
        [TBetSlipBetSubmissionExoticsType.Trifecta]: '精确三选',
      },
      totalStake: '总注额',
      bet: 'Bet',
      confirmBets: 'Confirm Bets',
      placeBets: '下注',
      placedBetsConfirmation: 'Your bets have been placed.',
      myBets: '我的投注',
      updateConfirmBets: 'Update & Confirm',
      login: 'Login & Bet',
      editBets: 'Edit Bets',
      done: 'Done',
      clearBets: '清除',
      makeADeposit: 'Make a deposit',
      lowerStakeHeading: 'Your balance is too low',
      lowerStakeDescription: 'Lower your stake or deposit',
      emptyBetSlipHeading: 'Your bet slip is empty',
      emptyBetSlipSubheading: 'Have a punt and gamble responsibly!',
      emptyMultiBets:
        'Add more single bets to create a multi, or combine with a same game multi and increase your potential win',
    },
  },
  Home: {
    PageTitle: '| Home',
    NextToJumpHeading: '即将开赛',
    UpcomingSportsHeading: 'Upcoming Sports',
    HorsesHeading: '赛马',
    GreyhoundsHeading: '赛狗',
    HarnessHeading: '赛马车',
    viewRaceCard: 'View Race Card',
  },
  Maintenance: {
    ContentHeaderBetGalaxy: 'Punter, we have a problem',
    ContentHeaderWellBet: 'Give us a minute!',
    OpeningTagline: 'We are currently having some technical issues at ',
    ClosingTaglineBetGalaxy:
      '. Ground control are looking into the issue as a high priority. We apologise and thank you for your patience.',
    ClosingTaglineWellBet:
      '. Our technical teams are looking for a solution as a high priority. We apologise and thank you for your patience.',
    OurOffices: 'Our Offices',
    Investigation:
      'We are currently investigating the issue. Please try again soon.',
  },
  Account: {
    PersonalDetails: {
      PageTitle: '| Personal Details',
      Header: 'Personal Details',
      Button: '保存更改',
      FirstNameInputLabel: '名',
      FirstNameErrorText: 'First Name is required',
      LastNameInputLabel: '姓',
      LastNameErrorText: 'Last Name is required',
      EmailInputLabel: '邮箱地址',
      MobileInputLabel: '手机',
      MobilePlaceholder: 'eg. 0412345678',
      MobileRequiredErrorText: 'Mobile is required',
      MobileNumberOnlyError: 'Mobile field can only contain numbers',
      AddressInputLabel: '居住地址',
      AddressInputPlaceholder: '* Address must match your ID',
      AddressInputManualPlaceholder: 'Manual Entry',
      AddressRequiredErrorText: 'Residential Address is required',
      AddressInputManualEntry: '看不到您的地址？请手动输入',
      DobInputLabel: '出生日期',
      DobInputError:
        'Sorry, you need to be over 18 years of age to use this platform',
      DobRequiredErrorText: 'Date of Birth is required',
      StreetNumberInputLabel: '街道号码',
      StreetNumberRequiredError: 'Street number is required',
      StreetNameInputLabel: '街道名称',
      StreetNameRequiredError: 'Street name is required',
      SuburbInputLabel: '区/县',
      SuburbRequiredError: 'Suburb is required',
      StateInputLabel: '州/省',
      StateRequiredError: 'State is required',
      PostcodeInputLabel: 'Postcode',
      PostcodeRequiredError: 'Postcode is required',
      PostcodeLengthError: 'Postcode must be 4 digits',
      SubmitSuccess: 'Personal details successfully updated.',
      SubmitError: 'There was an error updating your personal details',
    },
    UpdateEmail: {
      PageTitle: '| Update Email',
      Header: 'Update your email',
      EmailRequired: 'Your email address is required',
      SuccessMessage: 'Updated email successfully.',
      FailMessage: 'There was an issue updating your email',
    },
    VerifyIdentity: {
      PageTitle: '| Verify Identity',
      Header: 'Verify Your Identity',
      Failed: 'Unable to verify account',
      StatusInProgress: 'Your identity verification is in progress.',
      StatusPending: 'Your identity verification is pending manual review.',
      StatusComplete: 'Your identity is verified.',
      StatusFailed: 'Unable to verify your identity. Please',
      StatusFailedLink: 'contact support',
    },
    Overview: {
      MyAccount: '我的账户',
      PageTitle: '| Account Overview',
      VerificationStatus: 'Verification Status',
      GetVerified: 'Get Verified',
      AccountBalance: 'Account Balance: ',
      AccountNumber: '账号: ',
      Email: 'Email:',
      Deposit: '存款',
      WithdrawableBalance: 'Withdrawable Balance: ',
      Withdraw: 'Withdraw',
      BonusBalance: 'Bonus Balance: ',
      MustVerify: 'You must verify your account in order to make a withdrawal',
      Bonus: 'Bonus',
      Account: 'Account',
      Verification: {
        Verified: 'Verified',
        Pending: 'Pending',
        Unverified: 'Unverified',
      },
    },
    MyBets: {
      PageTitle: '我的投注',
      PendingView: 'Pending',
      ResultedView: 'Resulted',
      NoBetsText: 'You have no % bets',
      pending: 'pending',
      resulted: 'resulted',
      Loading: 'Loading...',
      ShowMore: 'Show more',
      NoBets: 'You have no more bets to display',
    },
    MyBetsCard: {
      BetIdText: 'Bet ID:',
      PotentialReturns: '预计回报',
      RaceAbbv: 'R',
      NoReturn: 'No Return',
      Won: 'Won',
      Lost: 'Lost',
      Stake: '注金',
      BetPlaced: 'Bet Placed On:',
      More: 'More',
      Less: 'Less',
      LegMulti: 'Leg Multi',
      Legs: 'Legs',
      BonusApplied: 'Bonus Applied',
      Badges: {
        BonusBet: 'Bonus Bet',
        Deductions: 'Deductions applied',
      },
    },
    SignedOut: {
      Title: 'The user is signed out',
    },
    CloseAccount: {
      title: '关闭您的账户',
      clickHere: '请点击此处。',
      text1: '您可以在此页面关闭您的账户。',
      text2: '如果您只想更改营销偏好（包括取消订阅），',
      text3: '如果您因无法再安全博彩而希望关闭账户，',
      confirmOpenAccounts:
        '您同意在账户关闭期间不再开设任何账户。您可以随时通过 service@goldenbet888.com.au 联系我们的客户服务团队，重新开启您的账户。',
      confirmPendingBets: '任何未决投注将保持有效，任何未决提款将得到处理。',
      confirmPendingBalance:
        '账户中的任何余额可通过向 service@goldenbet888.com.au 发电子邮件联系我们的客户服务团队进行提现。',
      confirmPassword: 'Confirm account closure with password',
      closeButton: 'Close account',
      errorMessage: 'Please try again',
      validationErrorMessage: 'Please complete the field to continue',
      passwordErrorMessage: 'Please check your password and try again.',
    },
    MakeAClaim: {
      title: 'Make a Claim',
      explanation:
        'Our claims process is designed to encourage the fast and efficient resolution of your issue at the first point of contact. While we will always aim to provide you with awesome customer service, we recognise that you may wish to express dissatisfaction with our products, services, staff or procedures.\n' +
        'While managing your complaint, we will aim to tailor any proposed resolutions to provide a fair and reasonable outcome to all parties involved. Once accepted, we will aim to deliver our mutually agreed resolution to you within 48 hours.\n' +
        'If your enquiry is related to feedback or staff compliments, you can contact us on our Customer Service line 1800 456 789.\n' +
        'If you are looking for a missing Bonus Bet, please contact us on our Customer Service line 1800 456 789.',
      contactUs: 'How to contact us:',
      contactUsDesc: 'Email us at: ',
      resolveClaims: 'How we resolve claims?',
      resolveClaimsDesc:
        'By email: We will respond to your complaint within 48 hours and provide you with an indication of how long it will take to resolve.',
      howWeResolve: 'How we resolve claims?',
      howWeResolveDesc:
        '- Your first and last name\n' +
        '- Account identification number\n' +
        '- Is this the first time you’re contact {themeName}? Y/N\n' +
        '- Complaint description (please include a bet receipt, operator name or market [if applicable])\n' +
        '- Preferred resolution\n' +
        '\n' +
        'This will allow us to investigate and deliver a response to you in a timely manner.',
    },
    LifetimeExclusion: {
      continueButton: '继续',
      pageTitle: '无期限自我禁止',
      information:
        '如果您正在考虑限制投注，您可以选择短暂休息（1 天至 30 天）或长期休息（6 个月至 5 年）。',
      informationShortBreak: '',
      informationText2: '',
      informationLongBreak: '',
      informationText3:
        '如果您决定长期不投注，我们提供无期限自我禁止选项。无期限自我禁止是永久性的，无法撤销。您的所有 {themeName} 账户将被永久关闭。您将来也不能开设新账户。您的禁止将在确认后立即开始。继续操作后，您将无法再使用 {themeName} 投注或在 {themeName} 开设有效账户。',
      informationText4:
        '继续操作后，您将无法再使用 {themeName} 投注或在 {themeName} 开设有效账户。',
      importantDetailsTitle: '重要详细信息',
      importantDetailsBalanceTitle: '{themeName} 余额',
      importantDetailsBalanceDesc:
        '您 {themeName} 账户中的任何资金将自动转入您最后一次使用的提款方式。如果您之前从未提款或希望将这些资金提取到其他账户，请致电 1800 888 888 联系客户服务。',
      importantDetailsAlertsTitle: '电子邮件和提醒',
      importantDetailsAlertsDesc:
        '您将不再收到 {themeName} 发送的电子邮件和其他提醒。这些将在您的休息确认开始后 24 小时内终止。',
      confirmLifetimeExclusion: '确认无期限自我禁止',
      confirm: '按下“继续”，即表示我理解：',
      confirmStepFunds:
        '我 {themeName} 账户中的所有资金将转入我最后一次使用的付款方式',
      confirmStepImmediately: '禁止条款将立即生效',
      confirmStepUndone:
        '禁止是永久性的，我在 {themeName} 的所有账户将被永久关闭',
      errorToast: 'Please try again',
      validationErrorMessage: 'Please complete the field to continue',
    },
    TakeABreak: {
      pageTitle: '休息一下',
      information:
        '您可以选择短暂休息 1 至 30 天，给自己一些远离投注的时间。您的休息将在确认后立即开始。',
      importantDetailsTitle: '重要详细信息',
      importantDetailsEmailTitle: '电子邮件和提醒',
      importantDetailsEmailDesc:
        '您将不再收到 {themeName} 发送的电子邮件和其他提醒。这些将在您的休息确认开始后 24 小时内终止。',
      importantDetailsLoginTitle: '登录',
      importantDetailsLoginDesc: '休息结束后，您立即就可以重新登录您的账户。',
      continueButton: '继续',
      confirmButton: 'Confirm break',
      breakStartDate: 'Break start date:',
      limitPeriod: '限额时长',
      confirm: '按下“继续”，即表示我理解：',
      confirmStepPendingBets:
        '我 {themeName} 账户中的所有资金将转入我最后一次使用的付款方式',
      confirmStepImmediately: 'My break will take effect immediately',
      confirmStepUndone: 'The break cannot be undone',
      today: '今天',
      dayPeriod: 'In X day',
      dayPeriodPlural: 'In X days',
      errorToast: 'Please try again',
      validationErrorMessage: 'Please complete the field to continue',
      period24: '24 hrs',
      period48: '48 hrs',
      period72: '72 hrs',
      periodWeek: '1 week',
      periodFortnight: '2 weeks',
      period1Month: '1 month',
      period3Months: '3 months',
      period6Months: '6 months',
      periodFormat: '(in X)',
    },
    Settings: {
      pageTitle: 'Settings',
      accountVerification: 'Account Verification',
      promotionsNotifications: 'Marketing Preferences',
      personalDetails: 'Personal Details',
      updateEmail: 'Update Email',
      responsible: '负责任博彩',
      terms: '使用条款',
      privacy: '隐私政策',
      makeAClaim: 'Make a Claim',
    },
    PromotionsNotifications: {
      pageTitle: 'Marketing Preferences',
      notificationsEnabled: 'Yes, I would like to receive promotional offers',
      via: 'via',
      email: '邮件',
      sms: '短信',
      phone: '手机',
      post: 'Post',
      SubmitSuccess: 'Marketing Preferences successfully updated!',
      SubmitError: 'Error updating marketing preferences...',
    },
    Transactions: {
      pageTitle: '交易',
      downloadAction: 'Download Spreadsheet',
      noTransactions: 'You have no more transactions to display',
      loading: 'Loading',
      showMore: 'Show More',
      downloadErrorMessage:
        "Something went wrong, couldn't download transactions...",
      tableHeadings: ['Date', 'Type', 'Details', '金额', '余额'],
    },
    BonusBets: {
      pageTitle: '礼金投注',
      downloadAction: 'Download Bonus Bets Transaction History',
      noBonusBets: 'You have no more Bonus Bets to display',
      downloadErrorMessage:
        "Something went wrong, couldn't download bonus bets transactions...",
    },
    Promos: {
      pageTitle: 'Promos',
    },
    Terms: {
      pageTitle: '使用条款',
      otherLinks: {
        privacy: '隐私政策',
        responsibleGambling: '负责任博彩',
        depositLimits: 'Deposit Limits',
      },
    },
    Privacy: {
      pageTitle: '隐私政策',
      otherLinks: {
        terms: '使用条款',
        responsibleGambling: '负责任博彩',
        depositLimits: 'Deposit Limits',
      },
    },
    DepositLimit: {
      depositLimit: '存款限额',
      SetLimit: {
        heading: '设置存款限额',
        subheading:
          '存款限额功能让您能够限制自己可向投注账户存入的最大金额。您可选择设置 1 天、7 天、14 天或 28 天的存款限额。金额应根据您的个人情况设定，并应仅为您认为自己能够承受的投注金额。',
        subheading2:
          'If you wish to change your existing Deposit Limit, you can do so at any time.  Increasing your limit does require a 7 day cooling-off period before it will take effect.  Lowering your limit, however will come into effect immediately.',
        inputPlaceHolder: 'Enter a deposit limit amount',
        depositLimitLabel: '限制金额',
        limitPeriodLabel: '限额时长',
        formSubText: 'You can deposit ',
        formSubTextBold: 'up to % every & days',
        setLimitButtonText: 'Set Deposit Limit',
        limitUpdated: 'Your deposit limit has been successfully updated.',
        error:
          'There was an error updating your deposit limit. Please try again.',
      },
      CurrentLimit: {
        heading: 'Deposit Limit Set',
        depositLimitLabel: '存款限额',
        limitPeriodLabel: '限额时长',
        limitPeriodUntil: 'The limit period cannot be changed until ',
        remainingMaxLimitLabel: 'Remaining max limit',
        increaseLimitAfter: 'Limit expiry',
        coolingOffEnds: 'Cooling off term ends',
        days: '% day(s)',
        dollars: '$',
        updateLimitHeading: 'Update Deposit Limit',
        canDecreaseSubheading:
          'You can decrease your deposit limit within the 7 day restriction period.',
        newLimitLabel: 'New deposit limit',
        saveLimitButtonText: 'Set new deposit limit',
        coolingOffStatement: 'Your limit will increase to % on the &',
      },
      UpdateConfirmModal: {
        title: 'Update Deposit Limit',
        subheading1Increasing:
          'Your update will take effect after the 7 day cooling-off period. You will then be able to deposit up to $% every & days.',
        subheading1Decreasing:
          'You will be able to deposit up to $% every & days. This will come into effect immediately.',
        cancel: 'Cancel',
        confirm: 'Confirm',
      },
      limitPeriodOptions: ['7 Days', '14 Days', '28 Days'],
      increaseUpdateConfirmed:
        'Deposit Limit updated. This change will come into effect in 7 days.',
      decreaseUpdateConfirmed:
        'Deposit Limit updated. This change will come into effect immediately.',
      errorStrings: {
        requiredAmount: '存款限额金额',
        cannotIncrease: 'Deposit limit cannot be increased until %',
        requiredPeriod: 'Deposit limit period is required',
        numbersOnly: 'Deposit limit can only contain numbers',
        sameValue: 'Amount entered is the same as your current deposit limit',
      },
    },
    Withdraw: {
      pageTitle: '提款',
      withdrawFundsTitle: 'Withdraw Funds',
      addbank: '添加新',
      bankCard: {
        acc: 'ACC',
        bsb: 'BSB',
        hiddenBsb: '*** ***',
        hiddenAccNumber: '*****',
      },
      withdrawalAmountLabel: '金额',
      withdrawalBalanceLabel: 'Available Balance: ',
      requestWithdrawalButton: '提款',
      withdrawalSuccess: 'Withdrawal request successful',
      withdrawSubFooter1:
        'Withdrawals may take up to 1-3 days to reach your account',
      withdrawSubFooter2: '只能提取流转过的资金。',
      withdrawalCancelled: 'Request successfully cancelled',
      errorStrings: {
        amountRequired: 'Withdraw amount is required',
        bankRequired: 'Bank account is required',
        minimumAmount: 'Withdraw amount must be more than $10',
        amountExceeds:
          'Your withdrawal request exceeds your current withdrawable balance of ',
        exceededWithDrawableAmount:
          'Your withdrawal request exceeds your current withdrawable balance. Please update your request or contact support for further assistance.',
        cannotWithdrawError:
          'You cannot withdraw funds until they’ve been turned over',
        integer: 'Withdraw amount can only contain numbers',
      },
      AddAccount: {
        heading: 'Add Bank Account',
        holderNameLabel: '账户持有人姓名',
        makeAWithdrawal: '进行提款',
        withdrawalDescription:
          'Requests may take up to 1-3 days to reach your account. Only turned over funds can be withdrawn.',
        holderNameSubFooter: '银行账户必须使用注册账户持有人的全名',
        bankNameLabel: 'Bank Name',
        bsbLabel: 'BSB 号码',
        accNumberLabel: '账号',
        nicknameLabel: '昵称（选填）',
        nicknameSubFooter:
          'Add a nickname to help distinguish this bank account from others',
        addAccountButton: '添加新账户',
        addAccountSubFooter:
          '请注意：资金只能提取到澳大利亚银行账户。如需帮助，',
        contactUs: '请联系我们。',

        errorStrings: {
          nameRequired: 'Account Holders name is required',
          bankNameRequired: 'Bank name is required',
          bsbRequired: 'BSB is required',
          bsbFormat: 'Must be a valid Australian BSB Number',
          accountNumberRequired: 'Account Number is required',
          accountNumberFormat: 'Must be a valid Australian Account Number',
          genericError: 'There was an error adding this bank account',
          AccountNumberNoSpaces: 'Account Number cannot contain spaces',
          BsbNumberNoSpaces: 'BSB Number cannot contain spaces',
          accountNameLength: 'Account Holder Name too long',
        },
      },
      Requests: {
        heading: 'Requests',
        cancelButton: 'Cancel',
        status: {
          withdraw: 'WITHDRAW',
          dash: ' - ',
          processing: 'Processing',
          unsuccessful: 'Unsuccessful',
        },
        requestUnsuccessful:
          'Request unsuccessful please contact customer support.',
        remove: 'Remove',
      },
      IncreaseAmountButton: {
        ten: '+$10',
        twentyFive: '+$25',
        fifty: '+$50',
        hundred: '+$100',
        twoHundred: '+$200',
        fiveHundred: '+$500',
      },
    },
    Deposit: {
      Titles: {
        Main: 'Make a deposit',
      },
      Labels: {
        CreditDeposit: 'Credit / Debit Card Deposit',
        SelectCard: 'Select a Card',
        Amount: '金额',
        SecuredWithSSL: 'Secured with SSL encryption technology.',
        minimumDepositAmount: '最低存款金额为 10 澳元',
      },
      Card: {
        Expired: 'Expired',
        SaveCard: 'Save card details',
      },
      Buttons: {
        Deposit: 'Deposit now',
        AddNewCard: 'Add New Card',
        AddCardAndDeposit: 'Add Card and deposit',
        MaxCards: 'You may only have up to * cards',
      },
      Validation: {
        MinAmount: 'Please enter a deposit amount of at least $10',
        MaxAmount: 'Your deposit limit has been reached.',
      },
      Confirmation: {
        Done: 'Done',
        PleaseTryAgain: 'Please, Try Again',
        Success: 'Success!',
        Complete: 'Deposit Complete',
        CompleteMessage: '% 澳元的存款已成功添加到您的账户。',
        Failed: 'Deposit Failed',
        FailedMessage: 'Your deposit of % was not successful.',
      },
      Toasts: {
        PaymentSuccessful: 'Successfully deposited your funds',
        PaymentUnsuccessful:
          'Payment was unsuccessful, you have not been charged',
        CardRemoveSuccessful: 'Card successfully deleted',
        UnableToProcessCard:
          'We were unable to process your card, please try again',
        UnableToDepositFunds: 'We were unable deposit your funds',
        SomethingWentWrong: 'Something went wrong, please try again',
        UnableToGetCards: 'Unable to get your saved cards',
        UnableToRemoveCard: 'Unable to remove your saved card',
        UnableToAddCard: 'Unable to add a new card',
        FZErrors: {
          '002': 'Unable to verify 3DS enrolment status with you issuer.',
          '003': '3DS authentication is unavailable with your issuer.',
          '004': 'Your issuer deems this transaction as risky.',
          '005': 'Your frictionless authentication has been rejected.',
          '006':
            'Unsuccessful authentication due to failed OTP (one time password) challenge.',
          '007':
            'You are enrolled for 3DS, but authentication is not available with your issuer.',
          '01': 'Contact your card issuer for more information',
          '02': 'Contact your card issuer for more information',
          '03': 'Check your merchant details provided',
          '04': 'Contact your card issuer for more information',
          '05': 'Contact your card issuer for more information',
          '06': 'Contact your card issuer for more information',
          '07': 'Contact your card issuer for more information',
          '12': 'Contact your card issuer for more information',
          '13': 'Invalid amount, contact your card issuer for more information',
          '14': 'Invalid card number, contact your card issuer for more information',
          '15': 'Contact your card issuer for more information',
          '19': 'Payment failed, please try again',
          '22': 'Payment failed, please try again',
          '23': 'Contact your card issuer for more information',
          '25': 'Contact your card issuer for more information',
          '30': 'Contact your card issuer for more information',
          '31': 'Your bank is not supported, contact your card issuer for more information',
          '33': 'Card has expired, please use a different card',
          '34': 'Card has expired, please use a different card',
          '35': 'Contact your card issuer for more information',
          '36': 'Contact your card issuer for more information',
          '37': 'Contact your card issuer for more information',
          '38': 'Please use another card',
          '39': 'Contact your card issuer for more information',
          '41': 'Contact your card issuer for more information',
          '42': 'Contact your card issuer for more information',
          '43': 'Contact your card issuer for more information',
          '44': 'Contact your card issuer for more information',
          '51': 'Insufficient funds',
          '52': 'Contact your card issuer for more information',
          '53': 'Contact your card issuer for more information',
          '54': 'Expired card, please use a different card',
          '55': 'Payment failed, please try again',
          '56': 'Contact your card issuer for more information',
          '57': 'Contact your card issuer for more information',
          '59': 'Contact your card issuer for more information',
          '60': 'Contact your card issuer for more information',
          '61': 'Please try another card',
          '62': 'Contact your card issuer for more information',
          '75': 'Please use another card',
          '82': 'Payment failed, please try again',
          '90': 'Payment failed, please try again',
          '91': 'Payment failed, please try again',
          '92': 'Payment failed, please try again',
          '93': 'Contact your card issuer for more information',
          '94': 'Contact your card issuer for more information',
          '96': 'Payment failed, please try again',
          '99': 'Payment failed, please try again',
        },
      },
      IncreaseAmountButton: {
        ten: '+10',
        fifty: '+50',
        hundred: '+100',
        fiveHundred: '+500',
        thousand: '+1000',
      },
    },
  },
  Sports: {
    ErrorMessages: {
      getCompetitionsFailMessage: "Couldn't load competitions for this sport",
      getMarketsFailMessage: "Couldn't load markets for this match",
      getMatchesFailMessage: "Couldn't load matches for this competition",
    },
    AllSports: {
      AZHeading: 'All Sports A-Z',
      TopSports: 'Top Sports',
      SportsListTitle: 'Sports A-Z',
    },
    CompetitionsBySport: {
      FeaturedCompetitionsTitle: 'Featured',
      AllCompetitionsTitle: 'All',
    },
    MarketsByMatch: {
      pageTitleFallback: 'Markets',
      noMarkets:
        'There are no markets for this event. Please check % for other active markets.',
      noMarketsButton: 'Go to',
      okayButtonText: 'Okay',
      matchClosed: 'Match % is now closed',
    },
    MatchCard: {
      versus: 'VS',
    },
    Propositions: {
      seeMore: 'See more',
      seeLess: 'See less',
    },
  },
  Racing: {
    ErrorMessages: {
      getRacingVenueListFailMessage: "Couldn't load venues",
      getRaceMetaFailMessage: "Couldn't load race meta data",
      getRaceRunnerListFailMessage: "Couldn't load race runner list",
      getOtherRacesByVenueFailMessage:
        "Couldn't load other races for this venue",
      getRaceResultsFailMessage: "Couldn't load race results",
      getRaceMarketsFailMessage: "Couldn't load race markets",
    },
    Exotics: {
      Exotics: 'Exotics',
      RaceResults: 'Race Results',
      addToBetSlip: 'Add to Bet Slip',
      flexi: 'Flexi',
      totalStake: 'Total Stake',
      betType: 'Bet Type',
      dividend: 'Dividend',
      dividends: 'Dividends',
      boxed: '合票',
      clearSelection: 'Clear Selection',
      combos: '组合',
      selectField: 'Select Field',
    },
    RaceDetails: {
      pageTitle: '| Race Details',
      runnerHeading: '跑步运动员',
      fixedHeading: 'Fixed',
      winHeading: 'Win',
      placeHeading: 'Place',
      raceStatusPrefix: 'Race',
      resultedStatus: 'Resulted',
      raceCardHeading: 'Race Card',
      marketTabs: {
        winPlace: 'Win/Place',
        raceResults: 'Win/Place',
      },
      resultsTabs: {
        results: 'Results',
      },
      eventRules: {
        ruleHeading: 'Event Rules: ',
        noPlace: 'No place betting available on this race',
        twoPlaceDividends: 'Only two place dividends paid',
        threePlaceDividends: 'Three place dividends paid',
      },
    },
    RaceResults: {
      RaceResults: 'Runners',
      win: 'Win',
      place: 'Place',
      positions: ['1st', '2nd', '3rd', '4th'],
    },
    RaceRunnerItem: {
      scratchedNoCaps: 'Scratched',
      scratched: 'SCRATCHED',
      suspended: 'SUS',
      deductions: 'Deductions applied',
    },
    RaceMeetings: {
      pageTitle: '| Race Meetings',
      Horses: 'Horses',
      Greys: 'Greys',
      Harness: 'Harness',
      NoRaces: 'No Races',
      Abandoned: 'ABND',
      Closed: 'CLSD',
    },
  },
  ContactUs: {
    Title: '联系我们',
    Support: 'Support - ',
    PhoneLocal: '(Local)',
    Chat: '在线客服',
    PhoneInternational: '(International)',
  },
  Legal: {
    Responsible: {
      heading: '负责任博彩',
      subHeading:
        '我们致力于保护和帮助我们的客户控制他们的博彩行为。我们提供多种支持选项以满足不同需求。',
      titles: {
        findOutMore: 'Find out more',
        getInTouch: '联系我们',
        takeAction: 'Take Action',
      },
      section: {
        findOutMore: {
          one: '与 Gambler’s Help 的专业人员聊天',
          two: '不确定您的博彩习惯？',
          three:
            ' 通过电话、面对面或在线与 Gambler’s Help 友好的工作人员聊天。这类聊天免费、保密、专业并且提供全天候服务。',
        },
        takeAction: {
          depositLimit: {
            one: '设置存款限额',
            two: 'Set a reasonable budget and control the amount of money deposited from your personal funds that you can afford to bet with.',
            button: '设置存款限额',
          },
          longTerm: {
            one: 'Long Term Exclusion',
            two: 'Stop betting by suspending your account for over 6 months or any other period up to a maximum of 5 years.',
            button: 'Long Term Exclusion',
          },
          deactivate: {
            one: 'Close my account',
            two: 'You can choose to close your account by deactivating it.',
            button: 'Close Account',
          },
          lifeExclusion: {
            one: '无期限自我禁止',
            two: `A lifetime exclusion is permanent and cannot be undone. All of your accounts with ${getThemeName()} will be closed permanently. You will not be able to set up a new account in the future.`,
            button: '无期限自我禁止',
          },
          break: {
            one: '休息一下',
            two: 'Take a break by suspending your account temporarily either for the remainder of the day or up to the next 6 months.',
            button: '休息一下',
          },
        },
      },
    },
  },
  Footer: {
    heading: '18+',
    subheading: 'Must be ',
    enquiries: 'For any enquiries email us at',
    support: 'Support - ',
    bodyMain2PhoneNumber: '1800 262 376',
    footerTopText1: `${getThemeName()}  gambling operations are governed by our Responsible Gambling Code of Conduct. Think! About your choices. Call Gambler’s Help or Gambling Help on 1800 858 858 or visit`,
    footertopText2:
      'Call Gambler’s Help Youthline on 1800 262 376. Gamble Responsibly.',
    footerBottomText:
      'In relation to South Australian residents, our gambling operations are also governed by the South Australian Responsible Gambling Code of Practice. Think of the people who need your support. Gamble Responsibly.',

    newFooterText1: `${getThemeName()} are committed to the support of responsible gambling. All bets are accepted by ${getThemeName()} who are licensed in Victoria by the Victorian Commission for Gambling and Liquor.`,
    newFooterText3:
      'Think of the people who need your support. Gamble Responsibly.',
    newFooterText4:
      'Please gamble responsibly and if you need help call Gambling Help services on',
    ourPartners: 'Our partners',
    weAccept: 'We accept',
    quickLinks: 'Quick links',
    bodyLink1: 'https://www.gamblershelp.com.au',
    bodyLink2: 'https://www.gamblinghelponline.org.au',
    bodySecondary: 'Licensed and regulated by Racing Victoria.',
    copyright: 'Copyright © {themeName} Pty Ltd | v',
  },
  SideNav: {
    home: 'Home',
    allSports: 'All Sports',
    myAccount: '我的账户',
    contactUs: 'Contact Us',
    racing: '竞速',
    sportAZ: '体育',
    quickLinks: 'QUICK LINKS',
    nextToJump: '即将开赛',
    viewAll: '查看全部',
    sports: '体育',
    deposit: 'Deposit Funds',
    promotions: 'Promos',
    withdraw: 'Withdraw Funds',
    depositLimits: 'Deposit Limits',
    responsible: '负责任的博彩工具',
    logout: 'Logout',
    login: 'Login',
    join: 'Join',
    Support: 'Support - ',
  },
};

export default STRINGS;
